import React, { useState, useRef, useCallback, useEffect } from 'react';
import { IconCamera01 } from '@pentabd/icons';
import Webcam from 'react-webcam';
import Modal, { ModalProps } from '../../atoms/modal/Modal';
import SectionHeader from '../section-header/SectionHeader';
import { Button } from '../../atoms/button';
interface ImageCaptureModalProps extends ModalProps {
  isOpenModal: boolean;
  captureImageHandlerButtonText?: string;
  resetImageHandlerButtonText?: string;
  takeImageHandlerButtonText?: string;
  title?: string;
  subtitle?: string;
  handleCloseModal: () => void;
  takeImageHandler?: (data: string) => void;
}

export default function ImageCaptureModal({
  title,
  subtitle,
  captureImageHandlerButtonText,
  resetImageHandlerButtonText,
  takeImageHandlerButtonText,
  takeImageHandler,
  isOpenModal,
  handleCloseModal,
  portal,
  closeAble = true,
  overlay = true,
}: ImageCaptureModalProps) {
  const [picture, setPicture] = useState<string>('');
  const [isTakeImgDisable, setIsTakeImgDisable] = useState<boolean>(false);

  const webcamRef = useRef<Webcam>(null);

  const capture = useCallback(() => {
    const pictureSrc = webcamRef.current?.getScreenshot() as string;
    setPicture(pictureSrc);
    setIsTakeImgDisable(true);
  }, [webcamRef]);

  const captureImageHandler = (e) => {
    e.preventDefault();
    capture();
  };

  const resetImageHandler = (e) => {
    e.preventDefault();
    setPicture('');
    setIsTakeImgDisable(false);
  };

  const verifiedImageHandler = (e) => {
    e.preventDefault();
    setIsTakeImgDisable(false);
    takeImageHandler(picture);
  };

  const clearPicture = () => {
    setPicture('');
    handleCloseModal();
  };

  const videoConstraints = {
    height: 350,
    width: 350,
    facingMode: 'user',
  };

  useEffect(() => {
    if (!isOpenModal) {
      setPicture('');
    }
  }, [isOpenModal]);

  return (
    <Modal
      isOpen={isOpenModal}
      portal={portal}
      closeAble={closeAble}
      overlay={overlay}
      onClose={clearPicture}
    >
      <div>
        <div className="px-9 pt-9">
          <SectionHeader title={title} subtitle={subtitle} />
        </div>

        {isOpenModal ? (
          <div className="d-flex justify-content-center border border-info rounded-3 mx-auto image-capture-mobile">
            {picture === '' ? (
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                videoConstraints={videoConstraints}
              />
            ) : (
              <img src={picture} className="w-100" alt="user-image" />
            )}
          </div>
        ) : null}

        <div className="d-flex justify-content-between p-9 ">
          <div>
            <Button
              fill="fill"
              type="info"
              size="sm"
              onClick={(e) => captureImageHandler(e)}
              disabled={isTakeImgDisable}
            >
              <IconCamera01 fill="white" size={20} />{' '}
              {captureImageHandlerButtonText}
            </Button>
          </div>
          <div className="d-flex justify-content-end gap-7">
            <Button
              onClick={(e) => resetImageHandler(e)}
              fill="outline"
              type="info"
              size="sm"
            >
              {resetImageHandlerButtonText}
            </Button>
            <Button
              fill="fill"
              type="info"
              size="sm"
              onClick={(e) => {
                verifiedImageHandler(e);
              }}
              disabled={picture === ''}
            >
              {takeImageHandlerButtonText}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
